import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';

const getPhotoCredit = (item) => {
    if (item.photographer && item.photographer_website) {
        return `<a href="${item.photographer_website}" target="_blank">${item.photographer}</a>`;
    }

    if (item.photographer) {
        return item.photographer;
    }

    if (item.photographer_website) {
        return `<a href="${item.photographer_website}" target="_blank">${item.photographer_website}</a>`;
    }

    return '';
};

const popup = document.getElementById('gallery-popup');
const psOptions = {
    closeOnScroll: false,
    tapToClose: false,
    bgOpacity: 0.9,
    addCaptionHTMLFn(item, captionEl, isFake) {
        let caption = item.caption || '';
        let photoCredit = getPhotoCredit(item);

        if (photoCredit) {
            caption += '<span class="photographer">';
            caption += '<img src="/themes/common/images/camera.svg" />';
            caption += photoCredit;
            caption += '</span>';
        }

        captionEl.children[0].innerHTML = caption || '';

        return !!caption;
    },
};

const psGalleries = downstageGalleries.map((gallery, galleryIndex) => {
    const items = gallery.photos.map((photo) => ({
        src: photo.image,
        w: photo.width,
        h: photo.height,
        title: ' ',
        caption: photo.caption,
        photographer: photo.photographer,
        photographer_website: photo.photographer_website,
    }));

    gallery.photos.forEach((photo, index) => {
        document.getElementById('photo-' + photo.id).onclick = (e) => {
            e.preventDefault();
            downstageGallery.show(galleryIndex, index);
        };
    });

    return items;
});

const downstageGallery = {
    show(galleryIndex, photoIndex = 0) {
        psOptions.index = photoIndex;
        const ps = new PhotoSwipe(
            popup,
            PhotoSwipeUI_Default,
            psGalleries[galleryIndex],
            psOptions,
        );
        ps.init();
    },
    init() {
        const hash = this.parseUrl();

        if (hash.pid && hash.gid) {
            this.show(hash.gid - 1, hash.pid - 1);
        }
    },
    parseUrl() {
        return window.location.hash
            .substring(1)
            .split('&')
            .filter((pair) => !!pair)
            .map((pair) => pair.split('='))
            .filter((pair) => pair.length === 2)
            .reduce((carry, current) => {
                const [key, val] = current;
                return Object.assign(carry, { [key]: parseInt(val, 10) });
            }, {});
    },
};

downstageGallery.init();
